import type { RouteRecordRaw } from 'vue-router';

/**
 * Ambiente público
 */
export const subsidiaryRoutes: Array<RouteRecordRaw> = [
  {
    name: 'PublicSubsidiaryLayout',
    path: '/cadastro-filial',
    props: false,
    meta: { requiresAuth: false },
    component: () => import('@/views/public/PublicLayout.vue'),
    children: [
      {
        name: 'PublicSubsidiary',
        path: ':token',
        props: true,
        component: () =>
          import('@/views/public/subsidiary/SubsidiaryRegistration.vue'),
        meta: { requiresAuth: false },
      },
    ],
  },
];
